import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Container,
  Button,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { useParams, useNavigate } from 'react-router-dom';
import Controls from '../controls/Controls';
import { useConstantsContext } from '../../context/constants_context';
import { useSettingContext } from '../../context/setting_context';
import { baseUrl, revenues } from '../../utils/constants';
import BillDetails from './BillDetails';

export default function Bill() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    refId: 0,
    billDate: '',
    created: false,
    posted: false,
    description: '',
    revenueAccount: 0,
    cycleId: 0,
    insuranceAmount: 0,
    subsAmount: 0,
    exchangeRate: 0
  });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const { subsAmount, assureAmount } = useSettingContext();
  const { payCycles } = useConstantsContext();
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });

  const BillSchema = Yup.object().shape({
    // subjectcode: Yup.string().required('Province is required'),
    // nameofsubject: Yup.string().required('Province is required')
  });

  useEffect(() => {
    console.log('id is here', id);
    if (id > 0) {
      console.log('id is here 2', id);
      getBillDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('id is again', formData);
  }, [formData]);

  formData.billDate = moment(formData.billDate).format('yyyy-MM-DD');

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: BillSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      saveBill(values);
    }
  });

  const saveBill = (e) => {
    const jsonClient = [];
    jsonClient.push(e);
    console.log('student stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/saveBill`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setFormData(result);
          navigate(-1);
          console.log('returned bill', result);
          setLoading(false);
          notifyPopup(`Bills Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving Bill!: ${error}`, 'error');
        }
      );
  };

  const processBilling = (e) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    console.log('post bills', e);
    const jsonClient = [];
    jsonClient.push(e);
    console.log('bulk receipt stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/ProcessBulkBillDetails?billNo=${e.id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          getBillDetail();
          console.log('returned bill bulk', result);
          setLoading(false);
          navigate(-1);
          notifyPopup(`Bill Details Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Processing Bulk Receipt Details!: ${error}`, 'error');
        }
      );
  };

  const getBillDetail = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/accounting/GetBill?billNo=${id}`).then(
      (res) => {
        setLoading(false);
        console.log('returned Bill', res);
        setFormData(res.data.result);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Card>
        <CardContent>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Typography variant="h6" gutterBottom>
                Membership Billing...
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="refId" label="BillNo" disabled />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.DateTime name="billDate" label="BillDate" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="description" label="Description" />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson
                    name="revenueAccount"
                    label="Revenue Account"
                    options={revenues}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="payCycleLbl">Stroke</InputLabel>
                    <Select
                      id="cycleId"
                      value={formik.values.cycleId}
                      name="cycleId"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('cycleId', e.target.value);
                        formik.setFieldValue('insuranceAmount', assureAmount);
                        formik.setFieldValue('subsAmount', subsAmount);
                      }}
                    >
                      <MenuItem key="" value="">
                        Not Selected
                      </MenuItem>
                      {payCycles.map((item) => (
                        <MenuItem key={item.payCycleId} value={item.payCycleId}>
                          {moment(item.payDate).isValid()
                            ? moment(item.payDate).format('YYYY-MM-DD')
                            : ''}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.InputNumber name="insuranceAmount" label="Insurance Amount" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.InputNumber name="subsAmount" label="Subscription Amount" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.InputNumber name="exchangeRate" label="Exchange Rate" />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.created} name="created" disabled />}
                    label="List Created"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.posted} name="posted" disabled />}
                    label="Bill Posted"
                  />
                </Grid>

                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="right"
                  alignItems="right"
                >
                  <Grid item xs={12} sm={1} marginRight={1} mr={2}>
                    <Button
                      type="submit"
                      variant="outlined"
                      startIcon={<SaveIcon />}
                      disabled={formik.values.created}
                    >
                      Save...
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={1} marginRight={1}>
                    <Button
                      type="button"
                      variant="outlined"
                      color="error"
                      startIcon={<ReceiptIcon />}
                      disabled={formik.values.posted || !formik.values.created}
                      onClick={() =>
                        setConfirmDialog({
                          isOpen: true,
                          title: 'Are you sure you want to process Current Batch',
                          subTitle: "You can't undo this action",
                          heading: 'Post Month Subscriptions',
                          color: '#76ff03',
                          onConfirm: () => {
                            processBilling({ id });
                          }
                        })
                      }
                    >
                      Post...
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
          {formData.refId > 0 && <BillDetails billNo={id} />}
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </CardContent>
      </Card>
    </Container>
  );
}
